import React from "react";

const RenderChildrenBasedOnScreen = (props) => {
  const { showOnMobile = false, children, showOnTablet = false } = props;

  let className = "hidden lg:block";

  switch (true) {
    case showOnMobile && showOnTablet:
      className = "block lg:hidden";
      break;
    case showOnMobile && !showOnTablet:
      className = "block sm:hidden";
      break;
    case showOnTablet && !showOnMobile:
      className = "hidden md:block";
      break;
    default:
      className = "hidden lg:block";
  }

  return <span className={className}>{children}</span>;
};

export default RenderChildrenBasedOnScreen;
